module.exports = __webpack_public_path__ + "static/media/Matafuegos02.9d4ada17.jpg";